// import Vue from 'vue'
import VueMarkdown from 'vue-markdown'
// import { mapGetters, mapActions } from 'vuex'

import Navigation from '@/components/Navigation'
import imageBlock from '@/components/imageBlock'
import List from '@/components/List'

export default {
  props: {
    page: {
      default: null,
      type: String
    },
    title: {
      default: '',
      type: String
    },
    description: {
      default: '',
      type: String
    },
    classes: {
      default: '',
      type: String
    },
    layout: {
      default: '',
      type: String
    }
  },
  components: {
    VueMarkdown,
    imageBlock,
    Navigation,
    List
  },
  data () {
    return {
      image: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    // console.log('TO: ', to, 'FROM: ', from, 'NEXT: ', next)
    // next((vm) => {
    //   vm.update(to, 'beforeRouteEnter')
    // })
  },
  methods: {
  },
  computed: {
    // ...mapGetters([
    //   'appConfig',
    //   'appData',
    //   'domain',
    //   'pages',
    //   'products'
    // ])
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  }
}



// WEBPACK FOOTER //
// ./src/scenes/_pageBase.js